import { atom } from 'jotai'
import {
	Expert,
	ExpertFilterModel,
	ExpertStartUp,
	ExpertStartUpFilterModel,
	SelectListItem,
} from './types'

export const expertsAtom = atom<Expert[]>([])
export const expertsStartupsAtom = atom<ExpertStartUp[]>([])

export const expertFilterAtom = atom<ExpertFilterModel>({
	expertTypeList: [],
	expertiseList: [],
	preferredLocalityList: [],
})

export const expertStartupFilterAtom = atom<ExpertStartUpFilterModel>({
	expertiseFocusList: [],
	expertiseList: [],
	preferredLocalityList: [],
})

export const preferredLocalitiesAtom = atom<SelectListItem[]>([])
export const expertTypesAtom = atom<SelectListItem[]>([])
export const expertisesAtom = atom<SelectListItem[]>([])
